import { useUserInformationContext } from 'contexts/userContext';
import React from 'react';
import { Route, RouteProps, useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { CURRENT_PATH } from 'utils/constants';

type Props = {
  adminOnly?: boolean;
} & RouteProps;

const ProtectedRouteOrder = ({ children, ...rest }: Props) => {
  const { path } = rest;
  const newPath = [...path as string].join("");
  const segmented = newPath?.split('/');
  const { currentUser } = useUserInformationContext();
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const isAllowedRoute = currentUser?.allowedRoutes?.has(segmented[segmented.length - 1]);

  const redirectToOverview = () => {
    localStorage.setItem(CURRENT_PATH, JSON.stringify({ view: 'overview' }));
    history.push(`/orders/details/${id}/overview`);
  };

  if (!isAllowedRoute && !currentUser?.is_admin) {
    redirectToOverview();
  }
  return (
    <Route
      {...rest}
      render={() => (children as any)}
    />
  );
};

export default ProtectedRouteOrder;
